const motivationalQuotes = [
  'You’re doing great, keep it up!',
  'Believe in yourself—you’ve got this!',
  'Every step you take brings you closer to your goals.',
  'Keep pushing forward, success is just around the corner.',
  'Stay focused and unstoppable!',
  'You are stronger than you think.',
  'Success is the sum of small efforts, repeated day in and day out.',
  'Your only limit is you.',
  'Believe you can and you’re halfway there.',
  'Don’t stop until you’re proud.',
  'Hard work beats talent when talent doesn’t work hard.',
  'The best way to predict the future is to create it.',
  'The only way to do great work is to love what you do.',
  'Success usually comes to those who are too busy to be looking for it.',
  'Don’t watch the clock; do what it does. Keep going.',
  'Opportunities don’t happen, you create them.',
  'The harder you work for something, the greater you’ll feel when you achieve it.',
  'Dream big and dare to fail.',
  'Success is not final, failure is not fatal: It is the courage to continue that counts.',
  'You are capable of amazing things.',
  'You miss 100% of the shots you don’t take.',
  'Believe in your dreams and they may come true.',
  'The future belongs to those who believe in the beauty of their dreams.',
  'Strive for progress, not perfection.',
  'Push yourself, because no one else is going to do it for you.',
  'Don’t limit your challenges, challenge your limits.',
  'Great things never come from comfort zones.',
  'Hardships often prepare ordinary people for an extraordinary destiny.',
  'Success is not how high you have climbed, but how you make a positive difference to the world.',
  'Start where you are. Use what you have. Do what you can.',
  'You are never too old to set another goal or to dream a new dream.',
  'It always seems impossible until it’s done.',
  'Do what you can with all you have, wherever you are.',
  'The harder you work, the luckier you get.',
  'Everything you need is already inside you.',
  'If you can dream it, you can do it.',
  'Success is a journey, not a destination.',
  'Don’t be pushed around by the fears in your mind. Be led by the dreams in your heart.',
  'Great things take time.',
  'The only limit to our realization of tomorrow is our doubts of today.',
  'You are what you believe.',
  'If you want it, work for it.',
  'Success is not about being the best, it’s about always getting better.',
  'The only way to achieve the impossible is to believe it is possible.',
  'Hard work and perseverance can make impossible things happen.',
  'The dream is free, but the hustle is sold separately.',
  'Keep your eyes on the stars and your feet on the ground.',
  'You’ve got to be willing to work for it.',
  'Your future is created by what you do today, not tomorrow.',
  'A year from now you may wish you had started today.',
  'Don’t wait for opportunity. Create it.',
  'Everything you want is on the other side of fear.',
  'Believe in yourself and all that you are.',
  'You’re capable of more than you know.',
  'It’s not whether you get knocked down, it’s whether you get up.',
  'Success is the sum of small efforts, repeated day in and day out.',
  'If you don’t build your dream, someone else will hire you to help them build theirs.',
  'The road to success and the road to failure are almost exactly the same.',
  'Success doesn’t come from what you do occasionally, it comes from what you do consistently.',
  'What you get by achieving your goals is not as important as what you become by achieving your goals.',
  'It does not matter how slowly you go as long as you do not stop.',
  'You don’t have to be great to start, but you have to start to be great.',
  'Life is what happens when you’re busy making other plans.',
  'Keep your face always toward the sunshine—and shadows will fall behind you.',
  'The best time to plant a tree was 20 years ago. The second best time is now.',
  "Your limitation—it's only your imagination.",
  'Sometimes later becomes never. Do it now.',
  'Great things never come from comfort zones.',
  'Dream it. Wish it. Do it.',
  'Success doesn’t just find you. You have to go out and get it.',
  'The harder you work, the more luck you seem to have.',
  'Dream bigger. Do bigger.',
  'Don’t stop when you’re tired. Stop when you’re done.',
  'Wake up with determination. Go to bed with satisfaction.',
  'Little things make big days.',
  'It’s going to be hard, but hard does not mean impossible.',
  'Don’t wait for opportunity. Create it.',
  'Sometimes we’re tested not to show our weaknesses, but to discover our strengths.',
  'The key to success is to focus on goals, not obstacles.',
  'Dream it. Believe it. Build it.',
  'The best way to predict the future is to create it.',
  'Success is not in what you have, but who you are.',
  'Do one thing every day that scares you.',
  'Challenges are what make life interesting. Overcoming them is what makes life meaningful.',
  'Everything you can imagine is real.',
  'You are braver than you believe, stronger than you seem, and smarter than you think.',
  'It always seems impossible until it’s done.',
  'The only way to do great work is to love what you do.',
  'Be yourself; everyone else is already taken.',
  'The only place where success comes before work is in the dictionary.',
  'Don’t stop when you’re tired. Stop when you’re done.',
  'Success doesn’t come from what you do occasionally, it comes from what you do consistently.',
  'Believe you can and you’re halfway there.',
  'You are capable of more than you know.',
  'It’s never too late to be what you might have been.',
  'If you don’t build your dream, someone else will hire you to help them build theirs.',
  'Success is not the key to happiness. Happiness is the key to success.',
  'What you do today can improve all your tomorrows.',
  'Do it with passion or not at all.',
  'Success is the sum of small efforts, repeated day in and day out.',
  'If you’re going through hell, keep going.',
  'You are capable of amazing things.',
  'Success isn’t just about what you accomplish in your life, it’s about what you inspire others to do.',
  'Hardships often prepare ordinary people for an extraordinary destiny.',
  'If you want to lift yourself up, lift up someone else.',
  'When you feel like quitting, think about why you started.',
  'Success doesn’t happen overnight.',
  'The road to success and the road to failure are almost exactly the same.',
  'What lies behind us and what lies before us are tiny matters compared to what lies within us.',
  'Success is not in what you have, but who you are.',
  'Success comes from having a vision, making a plan, and putting in the hard work.',
  'Great things take time, be patient.',
  'A year from now you may wish you had started today.',
  'If you want to achieve greatness, stop asking for permission.',
  'If you can dream it, you can do it.',
  'Focus on your goal. Don’t look in any direction but ahead.',
  'The journey of a thousand miles begins with one step.',
  'It does not matter how slowly you go as long as you do not stop.',
  'Believe in yourself and all that you are.',
  'Life is 10% what happens to us and 90% how we react to it.',
  'Great things are not done by impulse, but by a series of small things brought together.',
  'Success is the result of preparation, hard work, and learning from failure.',
  'In the middle of every difficulty lies opportunity.',
  'Success is not measured by what you accomplish, but by the obstacles you overcome.',
  'Act as if what you do makes a difference. It does.',
  'The secret of getting ahead is getting started.',
  'Don’t be afraid to give up the good to go for the great.',
  'Success is not just about making money. It’s about making a difference.',
  'What you get by achieving your goals is not as important as what you become by achieving your goals.',
  'Be not afraid of life. Believe that life is worth living, and your belief will help create the fact.',
  'You don’t have to be great to start, but you have to start to be great.',
  'Hard work beats talent when talent doesn’t work hard.',
  'Dream big, work hard, stay focused.',
  'The only way to do great work is to love what you do.',
  'Go the extra mile, it’s never crowded.',
  'Success is the sum of small efforts, repeated day in and day out.',
  "Don't count the days. Make the days count.",
  'You don’t have to be great to start, but you have to start to be great.',
  'The best way to predict the future is to create it.',
  'Success is walking from failure to failure with no loss of enthusiasm.',
  'Every great dream begins with a dreamer.',
  'Success doesn’t come to you, you go to it.',
  'Your life does not get better by chance, it gets better by change.',
  'Success comes from knowing that you did your best to become the best that you are capable of becoming.',
  'Success is not in what you have, but who you are.',
  'Believe you can and you’re halfway there.',
];

export default motivationalQuotes;
